import React, { useState } from 'react';

const Selector = ({ value, options, onChange, label, pill }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find(opt => opt.id === value) || options[0];
  return (
    <div className={`selector${open ? ' open' : ''}`} tabIndex={0} onBlur={() => setOpen(false)}>
      <div className="selector-main" onClick={() => setOpen((v) => !v)}>
        <img src={selected.logo} alt="logo" className="selector-logo" style={{ width: 24, height: 24 }} />
        <span className="selector-value">{selected.name}</span>
        <svg className="selector-arrow" width="18" height="18" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5" stroke="#bbb" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>
        <span className="selector-pill">{pill}</span>
      </div>
      {open && (
        <div className="selector-dropdown">
          {options.map(opt => (
            <div
              key={opt.id}
              className={`selector-dropdown-item${opt.id === value ? ' selected' : ''}`}
              onMouseDown={() => { onChange(opt.id); setOpen(false); }}
            >
              <span>{opt.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Selector; 